module.exports = __webpack_public_path__ + "assets/img/5.521a7f0a.png";